export const environment = {
  production: false,
  apiUrl: 'https://sbe-api-staging.schoolbell-e.com',
  schoolbellEWebLoginUrl: 'https://sbe-staging.schoolbell-e.com/login',
};
